// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"175":"7129178c","411":"9a76d694"}[chunkId] + ".chunk.css";
};